import React, { useState } from 'react';
import { MdOutlineAnalytics } from 'react-icons/md';
import RegistrationChart from './RegistrationChart';
import NurseRequestChart from './NurseRequestChart';

function DashboardMetrics() {
    const [period, setPeriod] = useState('daily');

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <h3 className="text-xl font-bold text-gray-800 dark:text-gray-200 flex gap-3 items-center">
                    <MdOutlineAnalytics className="h-7 w-7" />
                    Metrics
                </h3>

                <div className="flex flex-wrap gap-2">
                    <button
                        onClick={() => setPeriod('daily')}
                        className={`px-3 py-1.5 text-sm rounded-lg transition-colors ${period === 'daily'
                                ? 'bg-primary text-white'
                                : 'bg-base-200 text-neutral hover:bg-base-300 dark:bg-slate-700 dark:hover:bg-slate-600'
                            }`}
                    >
                        30 Days
                    </button>
                    <button
                        onClick={() => setPeriod('monthly')}
                        className={`px-3 py-1.5 text-sm rounded-lg transition-colors ${period === 'monthly'
                                ? 'bg-primary text-white'
                                : 'bg-base-200 text-neutral hover:bg-base-300 dark:bg-slate-700 dark:hover:bg-slate-600'
                            }`}
                    >
                        12 Months
                    </button>
                </div>
            </div>

            <RegistrationChart period={period} />
            <NurseRequestChart period={period} />
        </div>
    );
}

export default DashboardMetrics;